import type { SocialNetwork } from '@/models'

export const defaultSocialNetworks: SocialNetwork[] = [
  {
    url: 'https://youtube.com/SerasaConsumidor',
    name: 'Youtube',
    icon: 'youtube',
    description: 'Assine nosso canal e descomplique sua vida financeira.',
    acessibleText: 'Navegue para nosso canal no YouTube, abre nova guia em site externo.',
  },
  {
    url: 'https://instagram.com/serasa',
    name: 'Instagram',
    icon: 'instagram',
    description: 'Sua vida financeira mais saudável.',
    acessibleText: 'Navegue para nosso perfil no Instagram, abre nova guia em site externo.',
  },
  {
    url: 'https://open.spotify.com/show/5ZTMUau1ssfgmCIyvygpwt?si=fda7050e6a5f4110',
    name: 'Spotify',
    icon: 'spotify',
    description: 'Quem disse que educação financeira e entretenimento não combinam?',
    acessibleText: 'Navegue para nosso perfil no Spotify, abre nova guia em site externo.',
  },
  {
    url: 'https://www.facebook.com/serasa.com.br',
    name: 'Facebook',
    icon: 'facebook',
    description: 'Revolucionando a saúde financeira dos brasileiros.',
    acessibleText: 'Navegue para nosso perfil no Facebook, abre nova guia em site externo.',
  },
]
